import { Text } from 'common/common-components.styled';
import styled from 'styled-components';

export const StyledTitle = styled(Text)`
  color: ${({ theme }) => theme.colors.grey500};
  font-size: 12px;
  user-select: none;
  margin-right: 5px;
`;
